import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatAttachmentGroup'
})
export class FormatAttachmentGroupPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
  
    return value.split('-')[0] + ' ATTACHMENTS';
  }

}
